import { render, staticRenderFns } from "./FooterTreeColumnMobileTheme0.vue?vue&type=template&id=3c72daef&scoped=true"
import script from "./FooterTreeColumnMobileTheme0.vue?vue&type=script&lang=js"
export * from "./FooterTreeColumnMobileTheme0.vue?vue&type=script&lang=js"
import style0 from "./FooterTreeColumnMobileTheme0.vue?vue&type=style&index=0&id=3c72daef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c72daef",
  null
  
)

export default component.exports